import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TagItemComponent } from '@shared/components/tag-item/tag-item.component';
import { IDetails_Response, IRelatedItem } from '@shared/constants/models.const';
import { AddFrPipe } from '@shared/pipes/add-fr.pipe';
import { HorizontalDividerComponent } from '@shared/components/horizontal-divider/horizontal-divider.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-related-items',
  imports: [
    TagItemComponent,
    AddFrPipe,
    HorizontalDividerComponent,
    TranslateModule,
  ],
  templateUrl: './related-items.component.html',
  styleUrl: './related-items.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RelatedItemsComponent {
  pageData = input<IDetails_Response | any>();
  noBottomPadding = input<boolean>(false);

  tagsData = computed<IRelatedItem[]>(() => {
    if (this.pageData()?.relatedItems?.length) {
      return this.pageData()?.relatedItems;
    }
    if (this.pageData()?.relatedTagContainers?.length) {
      return this.pageData()?.relatedTagContainers;
    }

  });


}
